import React from "react";
import { Box, Typography } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import "react-awesome-slider/dist/styles.css";
import BlueBox from "../shared/blue-box";
import emptyIcon from "../../assets/images/empty.png";

const styles = (theme) => ({
  header: {
    color: "#707070",
    fontSizer: 15,
    fontWeight: 600,
    margin: 20,
  },
  subheader: {
    color: "#707070",
    fontSize: 12,
    fontWeight: 200,
    margin: "0 20px",
  },
  emptyIcon: {
    margin: "20px 0px",
  },
  descriptionBox: {
    width: 275,
  },
  description: {
    fontSize: 12,
    padding: "10px 0",
    color: "#707070",
    fontWeight: 100,
  },
});

const EmptyHint = ({ classes, nextSections }) => {
  return (
    <>
      <BlueBox text="Alle Schulungen bereits absolviert" />
      <Box
        display="flex"
        height="100vh"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Typography className={classes.header} variant="body1" component="p">
          Herzlich Willkommen bei unserem Aposphäre Campus
        </Typography>
        <Typography className={classes.subheader} variant="body1" component="p">
          <p>
            Du hast alle Schulungen bereits absolviert. Neue Schulungsinhalte
            gibt's kurz nach dem nächsten Vor-Ort-Termin. Schau danach also
            wieder hier vorbei! Wir freuen uns, Dich bald wiederzusehen.
          </p>
          <p>
            Hinweis Zertifikate: Wenn Du auf der Suche nach Deinen Zertifikaten
            bist,dann findest Du diese in der Menüsteuerung unter dem Bereich
            „Punkte“.
          </p>
          <p>
            Bei Fragen rund um den Aposphäre Campus, steht Dir Deine persönliche
            Trainerin jederzeit gerne zur Verfügung.
          </p>
        </Typography>
        <img
          alt="No courses left"
          src={emptyIcon}
          className={classes.emptyIcon}
        />
      </Box>
    </>
  );
};

export default withStyles(styles)(EmptyHint);
